export const ATTACHMENT_MAX_SIZE = '50Mb';

export const BOOK_SUBMISSION = Object.freeze({
  baseSubmissionAmount: 50,
  bookTypes: {
    default: 'default',
    illustrated: 'illustrated',
  },
  illustrationAcceptedTypes: [
    'image/jpeg',
    'image/png',
  ],
  maxBookNumber: 20,
  // Moment type
  minDiscoveryLaunchDate: {
    duration: 5,
    type: 'weeks',
  },
  minPublicationdate: {
    duration: -6,
    type: 'months',
  },
  maxLaunchDateForEdit: {
    duration: 3,
    type: 'months',
  },
  minIllustrations: 3,
  previousBooksAcceptedTypes: [
    'application/epub+zip',
    'application/x-mobipocket-ebook',
    'application/pdf',
  ],
  synopsisMaxWords: 200,
});

export const BOOKSHELF_ENTRY = Object.freeze({
  minReadDate: {
    duration: -50,
    type: 'years',
  },
});

export const CHECK_OAUTH_INTERVAL_MS = 700;

export const DASHBOARD_SEARCH = Object.freeze({
  anyRangeLabel: 'Any',
  defaultSortBy: 'recommended',
  selfPublished: 'self_published',
  traditionallyPublished: 'traditional_publisher',
});

export const DEBOUNCE_TIME = Object.freeze({
  fastest: 150,
  fast: 300,
  normal: 500,
  slow: 1000,
});

export const FIELDS_SIZE = Object.freeze({
  account: {
    password: {
      min: 8,
    },
  },
  profile: {
    about: {
      max: 300,
      min: 50,
    },
    whyBlogging: {
      min: 140,
    },
  },
  review: {
    didNotFinishDescription: {
      min: 140,
    },
    editorContent: {
      min: 300,
    },
    overview: {
      max: 140,
      min: 70,
    },
  },
});

export const FOLLOWERS_MODAL = Object.freeze({
  initialSearch: 24,
  moreResults: 12,
});

export const FOLLOWERS_SEARCH = Object.freeze({
  initialSearch: 60,
  moreResults: 30,
});

export const FOLLOWERS_TABS = Object.freeze({
  findFriends: 'find-friends',
  followers: 'followers',
  following: 'following',
  suggestions: 'suggestions',
});

export const INITIAL_BOOKSHELF = 'want_to_read';

export const MAX_GENRES = Object.freeze({
  author: 3,
  reviewer: 3,
});

export const MENTION_PLACEHOLDERS = Object.freeze({
  user: '@user-mention(<user-id>)',
});

export const POST_LINK_ENABLED_TYPES = [
  'AddExternalBookActivity',
  'AddExternalReviewActivity',
  'AddUserReviewActivity',
  'BadgeUnlockedActivity',
  'FeedPostActivity',
  'GoodreadsImportActivity',
  'LaunchedBookActivity',
  'LaunchedReviewActivity',
  'NewBookshelfEntryActivity',
];

export const POST_SOCIAL_ENABLED_TYPES = [
  'AddExternalBookActivity',
  'AddExternalReviewActivity',
  'AddUserReviewActivity',
  'BadgeUnlockedActivity',
  'FeedPostActivity',
  'GoodreadsImportActivity',
  'LaunchedBookActivity',
  'LaunchedReviewActivity',
  'NewBookshelfEntryActivity',
];

export const POST_TYPES = Object.freeze({
  default: 1,
  recommendation: 2,
  currentlyReading: 3,
  image: 4,
  poll: 5, // Used for UI only
  compareImages: 6,
  multipleChoice: 7,
});

export const REVIEW_TYPES = Object.freeze({
  video: 'video',
  written: 'written',
});

export const SCROLL_OPTIONS = Object.freeze({
  easing: 'ease-out',
  duration: 300,
  x: false,
  y: true,
});

export const NETWORK_UPDATES_PERIODICITY = [
  {
    text: 'Daily',
    value: 'daily',
  },
  {
    text: 'Weekly',
    value: 'weekly',
  },
  {
    text: 'Monthly',
    value: 'monthly',
  },
  {
    text: 'Never',
    value: 'never',
  },
];

export const IMAGE_DIMENSIONS = {
  bookCover: {
    width: 198,
  },
  bookCoverMobile: {
    width: 120,
  },
  facebookSignIn: {
    width: 192,
    height: 40,
  },
  googleSignIn: {
    width: 187,
    height: 43,
  },
  signupModalImage: {
    width: 480,
    height: 283,
  },
  reedsyLogo: {
    width: 117,
    height: 37,
  },
};

export const MONTHS = Object.freeze([
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]);
